import { MAPBOX_ACCESS_TOKEN } from '@/config';
import styled from 'styled-components';
import { SectionTitle } from './details-info-mod-styles';

const DEFAULT_STATIC_STYLE_SUBPATH = 'mapbox/outdoors-v11';
const PIN_TYPE = 'pin-m';
const SIZE = '580x190';
const ZOOM = 14;
const PIN_COLOR = '61687b';

function makeBaseUrlPath(styleSubpath) {
  return `https://api.mapbox.com/styles/v1/${styleSubpath}/static`;
}

const StyledDiv = styled.div`
  margin-bottom: 20px;

  page-break-inside: avoid;
`;

const StyledImg = styled.img`
  width: 100%;
  margin-top: 18px;
  cursor: pointer;
`;

function makeStaticMapUrl(
  lng,
  lat,
  styleSubpath = DEFAULT_STATIC_STYLE_SUBPATH
) {
  const pinType = `${PIN_TYPE}+${PIN_COLOR}`;
  const pinPosition = `${lng},${lat}`;
  const mapCenter = `${lng},${lat},${ZOOM}`;
  const accessToken = `access_token=${MAPBOX_ACCESS_TOKEN}`;
  const baseUrlPath = makeBaseUrlPath(styleSubpath);
  return `${baseUrlPath}/${pinType}(${pinPosition})/${mapCenter}/${SIZE}?${accessToken}`;
}

export function StaticLocationMapImage({
  lnglat,
  onClick,
  className,
  style,
  mapStyleSubpath,
}) {
  const [lng, lat] = lnglat;
  const staticMapUrl = makeStaticMapUrl(lng, lat, mapStyleSubpath);

  return (
    <StyledImg
      alt="Map showing a pin marking the property's position within a designated jurisdiction zone boundary"
      className={className}
      style={style}
      src={staticMapUrl}
      onClick={onClick}
    />
  );
}

export function LocationMod({ lnglat, onClick, mapStyleSubpath }) {
  return (
    <StyledDiv data-cy="property-details-map-tile">
      <SectionTitle>Location</SectionTitle>
      <StaticLocationMapImage
        lnglat={lnglat}
        onClick={onClick}
        mapStyleSubpath={mapStyleSubpath}
      />
    </StyledDiv>
  );
}
